export const clamp01 = (value: number) => Math.max(0, Math.min(1, value))
